import { Text } from "@chakra-ui/react";
import isEmpty from "lodash/isEmpty";
import { useContext } from "react";

import { FilterDetailsContext } from "../filter-details-context";

export const EmptyMessage = () => {
  const { paginationDetails, filterItems } = useContext(FilterDetailsContext)!;

  const { isLoading, isPaginating } = paginationDetails;

  const noLoading = !isLoading && !isPaginating;
  const noFilterItems = isEmpty(filterItems);
  if (noLoading && noFilterItems) {
    return (
      <Text className="text-center text-gray-500 py-4">No results found</Text>
    );
  }

  return null;
};
